<template>
    <div class="tool-list">
        <div
            v-for="item in imgList"
            class="tool-img"
            :class="activity === item.id ? 'active' : ''"
            :key="item.id"
            @click="setToolType(item)"
        >
            <i class="iconfont fs-24" :class="item.value"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'toolMain',
    props: {
        toolActivity: {
            type: Object,
            default: () => ({}),
        },
        eventCanEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activity: -1,
            scaleActivity: -1,
            imgList: [
                { id: 0, name: '矩形', type: 'rectangle', value: 'icon-a-Frame6356060' },
                // { id: 1, name: '多边形', type: 'polygn', value: 'icon-a-Frame6356062' },
                { id: 5, name: '复原照片', type: 'zoom', value: 'icon-Frame-2', num: 1 },
                { id: 6, name: '放大照片', type: 'zoomIn', value: 'icon-Frame-3', num: 0.01 },
                { id: 7, name: '缩小照片', type: 'zoomOut', value: 'icon-Frame-4', num: 0.01 },
            ],
        };
    },
    watch: {
        toolActivity: {
            handler(newValue) {
                this.activity = newValue.id;
            },
            deep: true,
        },
    },
    methods: {
        setToolType(event) {
            this.activity = event.id;
            if (event.id < 4) {
                this.$emit('tpChange', event);
            } else {
                this.$emit('setZoom', event);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.tool-list {
    display: flex;
    padding: 5px 0;
    .tool-img {
        margin:0 8px;
        color: #ffffff;
        cursor: pointer;
    }

    .active {
        color: #1890ff;
    }
    .fs-24 {
        font-size: 24px;
    }
}
</style>
